<template>
  <div class="report-table">
    <div class="report-table__head">
      <div>Услуги</div>
      <input-sort
        v-bind:class="{ selected: !!sortByTotalPrice }"
        v-model="sortByTotalPrice"
        v-on:input="emitSort('sortByTotalPrice', $event)"
        name="total-price"
        desc-first
        sort-class="sort"
      >
        Стоимость услуг
      </input-sort>
      <input-sort
        v-bind:class="{ selected: !!sortByDiscount }"
        v-model="sortByDiscount"
        v-on:input="emitSort('sortByDiscount', $event)"
        name="by-discount"
        desc-first
        sort-class="sort"
      >
        Скидки
      </input-sort>
      <input-sort
        v-bind:class="{ selected: !!sortByPaidAmount }"
        v-model="sortByPaidAmount"
        v-on:input="emitSort('sortByPaidAmount', $event)"
        name="paid-amount"
        desc-first
        sort-class="sort"
      >
        Оплачено
      </input-sort>
      <input-sort
        v-bind:class="{ selected: !!sortByDebt }"
        v-model="sortByDebt"
        v-on:input="emitSort('sortByDebt', $event)"
        name="debt"
        desc-first
        sort-class="sort"
      >
        Долг
      </input-sort>
    </div>
    <template
      v-for="(line, key) in resultLines"
    >
      <template v-if="line.hasDetails()">
        <button
          v-bind:key="`${key}-line`"
          class="report-table__row report-table__row--group"
          type="button"
          v-on:click="toggleDetails(line.groupName)"
        >
          <div data-label="Услуги" v-bind:title="line.groupNameTitle">{{ line.groupName }}</div>
          <div data-label="Стоимость услуг">{{ line.totalPrice }}</div>
          <div data-label="Скидки">{{ line.totalDiscount }}</div>
          <div data-label="Оплачено">{{ line.paidAmount }}</div>
          <div data-label="Долг">{{ line.debt }}</div>
        </button>
        <div
          v-for="(detail, detailKey) in line.details"
          v-bind:key="`${key}-line-${detailKey}-detail`"
          class="report-table__row report-table__row--detail"
        >
          <div data-label="Услуги" v-bind:title="detail.groupNameTitle">{{ detail.groupName }}</div>
          <div data-label="Стоимость услуг">{{ detail.totalPrice }}</div>
          <div data-label="Скидки">{{ detail.totalDiscount }}</div>
          <div data-label="Оплачено">{{ detail.paidAmount }}</div>
          <div data-label="Долг">{{ detail.debt }}</div>
        </div>
      </template>
      <template v-else>
        <div
          v-bind:key="`${key}-line`"
          class="report-table__row"
        >
          <div data-label="Услуги" v-bind:title="line.groupNameTitle">{{ line.groupName }}</div>
          <div data-label="Стоимость услуг">{{ line.totalPrice }}</div>
          <div data-label="Скидки">{{ line.totalDiscount }}</div>
          <div data-label="Оплачено">{{ line.paidAmount }}</div>
          <div data-label="Долг">{{ line.debt }}</div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import InputSort from '@/components/InputSort.vue';

export default {
  name: 'ReportTable',
  components: { InputSort },
  computed: {
    resultLines() {
      const lines = [...this.reportLines];
      return lines.map((line) => {
        if (line.hasDetails() && this.showedDetailsByLineKey.includes(line.groupName)) {
          return line;
        }
        return {
          groupName: line.groupName,
          totalPrice: line.totalPrice,
          totalDiscount: line.totalDiscount,
          paidAmount: line.paidAmount,
          debt: line.debt,
          summary: line.summary,
          summaryTitle: line.summaryTitle,
          groupNameTitle: line.groupNameTitle,
          hasDetails: line.hasDetails,
        };
      });
    },
  },
  data() {
    return {
      sortByTotalPrice: 'desc',
      sortByDiscount: '',
      sortByPaidAmount: '',
      sortByDebt: '',
      sortBySummary: '',
      showedDetailsByLineKey: [],
    };
  },
  methods: {
    /**
     * @description Поднять сортировку
     * @param type
     * @param direction
     */
    emitSort(type, direction) {
      this.clearSorts(type);
      this.$emit('input', { type, direction });
    },
    /**
     * @description Очистить другие сортировки
     * @param notClearableType
     */
    clearSorts(notClearableType = '') {
      this.sortByTotalPrice = notClearableType === 'sortByTotalPrice' ? this.sortByTotalPrice : '';
      this.sortByDiscount = notClearableType === 'sortByDiscount' ? this.sortByDiscount : '';
      this.sortByPaidAmount = notClearableType === 'sortByPaidAmount' ? this.sortByPaidAmount : '';
      this.sortByDebt = notClearableType === 'sortByDebt' ? this.sortByDebt : '';
      this.sortBySummary = notClearableType === 'sortBySummary' ? this.sortBySummary : '';
    },
    toggleDetails(key) {
      if (this.showedDetailsByLineKey.includes(key)) {
        this.showedDetailsByLineKey = this
          .showedDetailsByLineKey
          .filter((existKey) => existKey !== key);
      } else {
        this.showedDetailsByLineKey.push(key);
      }
    },
  },
  props: {
    needClearSorts: { type: Boolean, required: true },
    reportLines: { type: Array, required: true },
    initialSortType: { type: String, default: () => '' },
  },
  watch: {
    needClearSorts(value) {
      if (value === true) {
        this.clearSorts(this.initialSortType);
      }
    },
  },
};
</script>

<style lang="scss">
.report-table {
  &__head,
  &__row {
    width: 100%;
    text-align: left;
    display: grid;
    grid-template-columns: 1fr 150px 150px 150px 150px;
    align-items: center;
    font-size: 14px;
    line-height: 17px;
    border-bottom: 1px solid #eaeff3;
    padding: 12px 0;
    &--group {
      background: #c2d1d7;
    }
    &--detail {
      background: #eaeff3;
    }
    div {
      padding: 0 8px;
    }
  }
  &__head {
    width: 100%;
    font-weight: 700;
    border-bottom: 2px solid #0489e0;
    padding: 10px 0;
    div {
      padding: 0 8px;
    }
    .sort {
      text-align: left;
      display: flex;
      align-items: center;
      &:after {
        content: '';
        background-image: url("@/assets/img/checked/checked-grey.svg");
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        width: 10px;
        min-width: 10px;
        height: 10px;
        min-height: 10px;
        margin: 0 0 0 5px;
      }
      &:hover {
        text-decoration: none;
      }
    }
  }
}
.selected {
  color: var(--action-color);
}

@media screen and (max-width: 1200px) {
  .report-table {
    &__head {
      display: none;
    }
    &__row {
      grid-template-columns: 1fr;
      grid-gap: 5px;
      margin: 0 0 20px 0;
      div {
        display: flex;
        justify-content: space-between;
        text-align: right;
      }
      div:before {
        content: attr(data-label);
        font-weight: 700;
        margin-right: 20px;
      }
    }
  }
}
</style>
